import { Component } from '@angular/core';

@Component({
    selector: 'app-loading-animation',
    templateUrl: './loading-animation.component.html',
    styleUrls: ['./loading-animation.component.scss'],
    standalone: false
})
export class LoadingAnimationComponent {

}
